export default "__VITE_ASSET__ecd1a8ac__"